import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { GridLayout as Component } from './component';
import type { IDeps, IProps } from './models';

export const SmePartnersCommonGridLayout = createWidget<IDeps, IProps>()(Component);
